var render = function render(){var _vm=this,_c=_vm._self._c;return _c('contentCard',[_c('div',{staticClass:"no-auth-img"}),_c('div',{staticClass:"text"},[_vm._v(" 未模范履行业主义务的居民，暂无订餐权限。请到物业中心缴纳物业费，履行业主义务，如有疑问请联系社区工作人员：0574-55711314 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }